import { createFileRoute } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { AuthGuard } from '@/components/auth-guard';
import { ReadLaterPage } from '@/features/bookmarks';

function ReadLaterRoute(): ReactNode {
  return (
    <AuthGuard>
      <ReadLaterPage />
    </AuthGuard>
  );
}

export const Route = createFileRoute('/read-later')({
  component: ReadLaterRoute,
});
